import script from "./PoliticaPrivacidade.vue?vue&type=script&setup=true&lang=js"
export * from "./PoliticaPrivacidade.vue?vue&type=script&setup=true&lang=js"

import "@/assets/legal.css?vue&type=style&index=0&id=201b94bc&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-201b94bc"]])

export default __exports__